import { render, staticRenderFns } from "./BannerListDefaultLayout.vue?vue&type=template&id=524f29c6&scoped=true&"
import script from "./BannerListDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./BannerListDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524f29c6",
  null
  
)

export default component.exports